import { Box, Chip, Typography } from "@mui/material";
import { CustomEvent } from "schemas/functions";

interface IProps {
  isSelected: boolean;
  onClick?: (e?: CustomEvent) => void;
  label: string;
  color?: "primary" | "secondary";
}

export default function QuestionChip({
  isSelected,
  onClick,
  label,
  color = "primary",
}: IProps) {
  return (
    <Chip
      icon={
        isSelected ? (
          <Box
            sx={{
              background: "white",
              width: "20px",
              height: "20px",
              ml: "8px !important",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component="span"
              sx={{ color: `${color}.dark` }}
              className="fa-regular fa-check"
            />
          </Box>
        ) : undefined
      }
      variant={isSelected ? "filled" : "outlined"}
      color={isSelected ? color : "default"}
      onClick={onClick}
      label={
        <Typography
          sx={{
            fontSize: { xs: 10, md: 13, color: isSelected ? "white" : "black" },
          }}
        >
          {label}
        </Typography>
      }
    />
  );
}
